export default {
  title: 'v{version}',
  notification: 'Доступна новая версия <strong>{version}</strong>.</br>Обновите страницу.',

  notifications: {
    copied: 'Версия скопирована'
  }
}
